<template>
  <v-content>
    <v-layout mt-12>
      <v-spacer></v-spacer>
      <v-flex xs11>
        <v-layout wrap class="justify-center">
          <v-flex
            shrink
            v-for="(content, index) in contents"
            :key="index"
            class="pa-2"
            style="cursor: pointer"
          >
            <v-hover
              v-slot:default="{ hover }"
              open-delay="50"
              style="cursor: pointer"
            >
              <v-card
                width="300"
                class="justify-center pb-2"
                :elevation="hover ? 10 : 0"
              >
                <div>
                  <v-img
                    class="mb-2"
                    :src="content.image"
                    :contain="content.image ? false : true"
                  ></v-img>
                </div>
                <div class="pl-6">
                  <span>{{ content.name }}</span>
                </div>
                <div class="pl-6">
                  <span style="color: #828282"
                    >วันที่อัพเดตล่าสุด : 8 ก.ค. 2563</span
                  >
                </div>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>

    <v-layout class="justify-center my-12">
      <v-flex shrink>
        <v-btn outlined color="#FD5246">
          <span>{{ $t("more") }}</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Content",
  components: {
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    contents: [
      {
        id: 1,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 2,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 3,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 4,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 5,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 6,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 7,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 8,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 9,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
      {
        id: 10,
        name: "Article",
        image: require("../assets/tcdc-color.png"),
      },
    ],
  }),
  computed: {
    ...mapState({
      portfolioArticles: (state) => {
        return state.portfolio.portfolio_categorys.portfolios;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  methods: {},
};
</script>

<style scoped></style>
